import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { BonusActivitCallBackData } from 'src/app/shared/interfaces/bank-card.interface';
import { BonusList } from 'src/app/shared/interfaces/bonus.interface';
import { LocaleService } from 'src/app/shared/service/locale.service';

export interface DepositBonusPreservedState {
  selectedBonus: string;
  bonusList: BonusList[];
}
@Injectable({ providedIn: 'root' })
export class DepositBonusDropdownService {
  constructor(
    private localeService: LocaleService,
    private bonusApi: BonusApi,
  ) {}

  /** bonus 暫存資料集合 */
  preservedBonusState: DepositBonusPreservedState | null = null;
  /** 獲取到暫存資料之後要清除，以免影響其他資料   */
  clearBonusState(): void {
    this.preservedBonusState = null;
  }

  private cachedSelections = new Map<string, string>();

  private getCacheKey(uid: string, currency: string): string {
    return `${uid}:${currency}`;
  }

  getCachedSelection(uid: string, currency: string): string | undefined {
    return this.cachedSelections.get(this.getCacheKey(uid, currency));
  }

  saveCachedSelection(uid: string, currency: string, activityNo: string): void {
    this.cachedSelections.set(this.getCacheKey(uid, currency), activityNo);
  }

  clearCachedSelection(uid: string, currency: string): void {
    this.cachedSelections.delete(this.getCacheKey(uid, currency));
  }

  /**
   * 獲取存款紅利
   * @param currency
   * @param amount
   * @returns
   */
  getDepositBonus(currency: string = 'USDT', amount: number = 100000): Observable<BonusList[]> {
    return this.bonusApi.getBonusActivity({ currency, amount }).pipe(
      map(x => {
        return (
          x
            ?.filter(v => v?.bonusActivitiesNo !== 'couponcodedeposit') // 过滤 兑换券
            ?.map((item: BonusActivitCallBackData, key: number) => {
              const activityTypeName = this.getActivityType(item?.activityType, item?.labels);
              const grantTypeName = this.getGrantType(item?.prizeType);
              return {
                ...item,
                index: key,
                isActive: false,
                activityTypeName,
                grantTypeName,
              };
            }) || []
        );
      }),
    );
  }

  /**
   * 获取红利 活动类型
   * @param type
   * @param labels
   * @returns
   */
  getActivityType(type: string, labels: string[]): string[] | [] {
    // 已经和后端沟通 需要变成活动标签
    //1=bonus，2=vip
    if (type == '1') {
      return labels;
    } else {
      return [this.localeService.getValue('vip_bene00'), ...labels];
    }
  }

  /**
   * 获取红利券类型
   * @param type
   * @returns
   */
  getGrantType(type: number) {
    // 发放方式 1:现金券,2:抵用金,3:SVIP体验券,4:实物,5:装备,6:Free Spin,7:后发现金券
    const types: { [key: number]: string } = {
      1: this.localeService.getValue('cash_coupons'),
      2: this.localeService.getValue('select_coupon'),
      3: 'SVIP' + this.localeService.getValue('svip_coup'),
      4: this.localeService.getValue('in_kind_coupons'),
      5: this.localeService.getValue('equipment_coupons'),
      6: this.localeService.getValue('free_spin_coupons'),
      7: this.localeService.getValue('after_cash_coupons'),
      8: this.localeService.getValue('none_sticky'),
    };
    return types[type];
  }

  /**
   * 根據prizeAmountType轉換bonus顯示的文字
   * 0:不指定 1:固定金額 2:固定比例
   * @param prizeAmountType
   * @param item
   * @returns
   */
  prizeAmountTypeTmp(item: BonusList) {
    switch (item.prizeAmountType) {
      case 0:
        return `${item.bonusActivityName || ''} , ${
          item.freeSpinTimes || 0
        } ${this.localeService.getValue('num_times')}`;
      case 1:
        return `${item.bonusActivityName || ''} , ${item.bonusFixedUsdt || 0} USDT`;
      case 2:
        return `${item.bonusActivityName || ''} , ${item.returnPercentage || 0}%`;
      default:
        return `${item.returnPercentage || 0}%`;
    }
  }

  /**
   * 保存 bonus 信息
   * @param selectedBonus
   * @param bonusList
   */
  saveBonusInfo(selectedBonus: string, bonusList: BonusList[]): void {
    this.preservedBonusState = {
      selectedBonus,
      bonusList,
    };
  }
}
